import React from 'react';
import Caret from '../../components/Caret';
import IconButton from '../../components/IconButton';
import Tooltip from '../../components/Tooltip';
import styles from './CategoryHeadingButton.module.scss';

interface CategoryHeadingProps {
  selectedEntityCategory?: string | null;
  onHeaderClick: () => void;
}

const CategoryHeadingButton = ({
  selectedEntityCategory,
  onHeaderClick,
}: CategoryHeadingProps) => {
  return (
    <Tooltip
      tooltip={selectedEntityCategory ? 'Go back' : 'Show all'}
      trigger="hover"
      placement="bottom"
      display="block"
      popOverPortal={document.body}
    >
      <IconButton
        className={styles.icon}
        onClick={() => onHeaderClick()}
        size="small"
      >
        <Caret
          direction={selectedEntityCategory ? 'left' : 'right'}
          size={10}
        />
      </IconButton>
    </Tooltip>
  );
};

export default CategoryHeadingButton;
